import * as SelectPrimitive from "@radix-ui/react-select";
import * as React from "react";

import { cn } from "../../../utils";
import { CommandGroup } from "../../Command";
import { SelectContext } from "./context";

export function SelectGroup({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof SelectPrimitive.Group>) {
  const ctx = React.useContext(SelectContext);

  if (ctx.isSimple) {
    return (
      <SelectPrimitive.Group className={className} {...props}>
        {children}
      </SelectPrimitive.Group>
    );
  }

  return (
    <CommandGroup
      className={cn("py-1", className)}
      {...(props as React.ComponentPropsWithoutRef<typeof CommandGroup>)}
    >
      {children}
    </CommandGroup>
  );
}

SelectGroup.displayName = SelectPrimitive.Group.displayName;
